(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('#drawer-cart [name="checkout"]');
    if (!button) return;
    if (button.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
  }, true);

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('#drawer-cart form.cart')) return;
    const button = event.target.querySelector('[name="checkout"]');
    if (!button) return;
    if (button.dataset.nwSubmitted === 'true') {
      event.preventDefault();
      return;
    }
    button.dataset.nwSubmitted = 'true';
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
  }, true);

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('#drawer-cart [name="checkout"]').forEach(button => {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      delete button.dataset.nwSubmitted;
    });
  });

  document.addEventListener('theme:cart:popdown', async (event) => {
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (window.theme.settings.cart_style !== 'drawer' || !drawer) return;
    event.stopImmediatePropagation();
    try {
      const response = await fetch(`${window.theme.routes.cart}.js`);
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open'));
    } catch (error) {
      console.error(error);
      window.location.assign(window.theme.routes.cart);
    }
  }, true);

  document.addEventListener('theme:cart:change', (event) => {
    if (!event.detail || !event.detail.cart) return;
    const cart = event.detail.cart;
    document.querySelectorAll('[data-nw-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    document.querySelectorAll('#drawer-cart [data-cart-message]').forEach(message => {
      const limit = Number(message.dataset.limit) * 100;
      message.style.setProperty('--nw-shipping-progress', `${limit > 0 ? Math.min(100, cart.total_price / limit * 100) : 0}%`);
    });
    if (cart.total_price !== 0) return;
    document.querySelectorAll('#drawer-cart [data-cart-message]').forEach(message => {
      message.classList.remove('is-success', 'is-hidden');
      const amount = message.querySelector('[data-empty-cart-amount]');
      if (amount) amount.innerHTML = amount.dataset.emptyCartAmount;
      const progress = message.querySelector('[data-cart-progress]');
      if (progress) progress.style.strokeDashoffset = String(28 * Math.PI);
    });
  });

  function connectDrawer() {
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer || drawer.dataset.northwindConnected) return;
    drawer.dataset.northwindConnected = 'true';
    let closingTimer;
    const updateExpanded = () => {
      const expanded = drawer.classList.contains('drawer--visible');
      clearTimeout(closingTimer);
      if (expanded) {
        document.body.classList.add('northwind-cart-open');
      } else if (document.body.classList.contains('northwind-cart-open')) {
        closingTimer = setTimeout(() => {
          if (!drawer.classList.contains('drawer--visible')) {
            document.body.classList.remove('northwind-cart-open');
          }
        }, 850);
      }
      document.querySelectorAll('[data-drawer-toggle="drawer-cart"]').forEach(button => {
        button.setAttribute('aria-expanded', String(expanded));
      });
    };
    new MutationObserver(updateExpanded).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    updateExpanded();
  }
  connectDrawer();
  document.addEventListener('shopify:section:load', connectDrawer);
})();
